import { SxProps, Theme } from '@mui/material';

export const productCardSX: SxProps<Theme> = (theme: Theme) => ({
	p: '10px',
	width: '100%',
	height: '630px',
	display: 'flex',
	flexDirection: 'column',
	borderRadius: 0,
	'&:hover': {
		boxShadow: 3,
	},
	'&:focus-visible': {
		outline: 0,
	},
	[theme.breakpoints.down('lg')]: {
		height: '550px',
	},
});

export const productCardBundleIconsSX: Record<string, SxProps> = {
	container: {
		height: '75px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
	},
	iconBox: {
		border: '1px solid',
		borderColor: 'grey.50',
		borderRadius: '3px',
		width: 24,
		height: 24,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		overflow: 'hidden',
	},
	icon: {
		width: '100%',
		height: '100%',
	},
	iconText: { color: 'grey.500', ml: '10px' },
};

export const productCardPriceBoxSX: SxProps = {
	height: '45px',
	mx: '5px',
	mb: '15px',
};
